var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { LocalStorageKeys } from '@/types';
export var RECENT_PROJECTS_LIMIT = 5;
export function buildRecentProjectsStorageKey(companyId, userId) {
    return LocalStorageKeys.RecentProjects + ":" + companyId + ":" + userId;
}
function resolveStorageKey(scope) {
    if (!scope.companyId || !scope.userId)
        return '';
    return buildRecentProjectsStorageKey(scope.companyId, scope.userId);
}
function isRecentProjectItem(item) {
    return (!!item &&
        typeof item === 'object' &&
        typeof item.id === 'string' &&
        typeof item.title === 'string');
}
export function loadRecentProjects(scope) {
    if (!process.client)
        return [];
    var key = resolveStorageKey(scope);
    if (!key)
        return [];
    try {
        var raw = localStorage.getItem(key);
        if (!raw)
            return [];
        var parsed = JSON.parse(raw);
        if (!Array.isArray(parsed))
            return [];
        return parsed.filter(isRecentProjectItem).slice(0, RECENT_PROJECTS_LIMIT);
    }
    catch (e) {
        return [];
    }
}
/** 新しい案件を先頭に追加（同一 id は除外）。最大 RECENT_PROJECTS_LIMIT 件。 */
export function pushRecentProject(scope, project) {
    var key = resolveStorageKey(scope);
    if (!process.client || !key || !project.id)
        return loadRecentProjects(scope);
    var title = (project.title && String(project.title).trim()) || project.id;
    var next = __spreadArrays([
        { id: project.id, title: title }
    ], loadRecentProjects(scope).filter(function (item) { return item.id !== project.id; })).slice(0, RECENT_PROJECTS_LIMIT);
    try {
        localStorage.setItem(key, JSON.stringify(next));
    }
    catch (e) {
        // localStorage 不可時は無視
    }
    return next;
}
/**
 * ログアウト・ログイン成立時に、全ユーザー分の履歴を消す。
 * 会社・ユーザーで分ける前の旧キー（ccw_recent_projects 単体）も、持ち主が判別できないため併せて消す。
 */
export function clearRecentProjectsStorage() {
    if (!process.client)
        return;
    var legacyKey = LocalStorageKeys.RecentProjects;
    var prefix = legacyKey + ":";
    var removeKeys = [];
    for (var index = 0; index < localStorage.length; index++) {
        var key = localStorage.key(index);
        if (key && (key === legacyKey || key.startsWith(prefix))) {
            removeKeys.push(key);
        }
    }
    removeKeys.forEach(function (key) {
        localStorage.removeItem(key);
    });
}
